import { h, render } from 'preact';
import clsx from 'clsx';
import ContentBlock from '../flexible-content/ContentBlock';
import { resolveAspect } from '../flexible-content/constants';

const px = (value) => (typeof value === 'number' && value > 0 ? `${value}px` : undefined);

// mobile_first flips which cell leads when the row stacks on mobile, without
// touching desktop order.
export default (element, data) => {
  const Section = () => {
    const sides = data.sides || [];
    const mobileReverse = data.mobile_first === 'second';

    return (
      <div
        className={clsx(
          'flex laptop:flex-row w-full',
          mobileReverse ? 'flex-col-reverse' : 'flex-col',
          data.is_bordered && 'flexible-border',
        )}
        style={{
          background: data.section_bg || undefined,
          ...(data.is_bordered
            ? {
              '--fb-color': data.border_color || undefined,
              '--fb-width': px(data.border_width),
              '--fb-width-mobile': px(data.border_width_mobile),
            }
            : {}),
        }}
      >
        {sides.map((side, i) => {
          const ar = resolveAspect(side);
          return (
            <div
              // self-start keeps the flex row from stretching the cell and
              // overriding its aspect-ratio height.
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              className={clsx(
                'laptop:w-1/2 flex',
                ar && 'laptop:self-start',
                side.hide_on_mobile && 'hidden laptop:flex',
              )}
              style={ar ? { aspectRatio: String(ar) } : undefined}
            >
              <ContentBlock side={side} sectionIndex={data.section_index} />
            </div>
          );
        })}
      </div>
    );
  };

  render(<Section />, element);
};
